export const ACCESS_DENIED_NOTICE_KEY = 'accessDeniedNotice';
